import React from 'react'

const FloorPlan = () => {
  return (
    <div>
        <img src="Floorplan1.png" height='100%' width='100%'></img>
        <img src="Floorplan2.png" height='100%' width='100%'></img>
        <img src="Floorplan3.png" height='100%' width='100%'></img>
    </div>
  )
}

export default FloorPlan